module.exports = __webpack_public_path__ + "img/document-reject.952ae199.svg";